export default {
      id: "home-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "img/icons.e72ac2e3.svg#home",
      toString: function () {
        return this.url;
      }
    }